module.exports = __webpack_public_path__ + "img/20250310.9613db05.png";